import BibliaOnline from "./biblia-online";
import EvangelhoMeditado from "./evangelho-meditado";

class Espiritualidade {
	constructor() {
		this.handleSections();
		this.handleUrlsParams();

		new BibliaOnline();
		new EvangelhoMeditado();
	}

	handleUrlsParams() {
		const params = new URLSearchParams(window.location.search);
		this.selectTab(params.get('tab'));
	}

	selectTab(param) {
		const section = document.querySelector(`#espiritualidade-content .heade-navigation > ul > li[data-section="${param}"]`);

		if (section) {
			this.cleanUpSections();
			section.classList.add('selected');
			this.showSelectedSection(param)
		}
	}

	handleSections() {
		const sections = document.querySelectorAll('#espiritualidade-content .heade-navigation > ul > li');

		sections.forEach(section => {
			section.addEventListener('click', () => {
				this.cleanUpSections();
				section.classList.add('selected');

				this.showSelectedSection(section.getAttribute('data-section'));
			});
		});
	}

	cleanUpSections() {
		const sections = document.querySelectorAll('#espiritualidade-content .heade-navigation > ul > li');

		sections.forEach(section => {
			section.classList.remove('selected');
		});
	}

	showSelectedSection(sectionId) {
		const sections = document.querySelectorAll('.espiritualidade-container > .sections > section');
		const section = document.querySelector(`#${sectionId}`);

		sections.forEach(section => {
			section.classList.add('deactive');
		});

		if (section) {
			section.classList.remove('deactive');
		}

	}
}

document.addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('#espiritualidade-content');

	if (container) {
		new Espiritualidade();
	}
})
